<script>
  import { Swiper, SwiperSlide } from 'swiper/svelte'
  import { Navigation, Pagination } from 'swiper'
  import 'swiper/css'
  import 'swiper/css/navigation'
  import 'swiper/css/pagination'

  const gallery = [
    '1.jpg',
    '2.jpg',
    '3.jpg',
    '4.jpg',
    '5.jpg',
    '6.jpg',
    '7.jpg',
    '8.jpg',
    '9.jpg',
    '10.jpg',
    '11.jpg',
    '12.jpg',
    '13.jpg',
    '14.jpg',
    '15.jpg',
    '16.jpg',
    '17.jpg'
  ]
</script>
  
<section class="gallery mt-20">
  <Swiper
    modules={[Navigation, Pagination]}
    spaceBetween={50}
    slidesPerView={1}
    navigation
    pagination={{ clickable: true }}
  >
    {#each gallery as galleryImage }
      <SwiperSlide>
        <img src="assets/gallery/{galleryImage}" alt="">
      </SwiperSlide>
    {/each}
  </Swiper>
</section>

<style>
  .gallery :global(.swiper) {
    @apply pb-16;
  }
  .gallery :global(.swiper-slide) {
    @apply px-14;
  }
  .gallery :global(.swiper-button-next),
  .gallery :global(.swiper-button-prev) {
    @apply -translate-y-2/4;
  }
</style>